// types
import sessionActionTypes from '../action_types/session-action-types'

interface ISession {
	fullName: boolean
	firstName: string | undefined
	lastName: string | undefined
	middleName: string | undefined
	surname: string | undefined
	needFirstReport: boolean
	patients: Array<any>
	services: Array<any>
	userWithoutLogin: boolean
	userGigya: boolean
	registrationFinished: boolean
	userMemberships: {
		sura: boolean
		ipsComfama: boolean
		boxComfama: boolean
		suscription: boolean
		haveCareCenterPlan: boolean
	}
	permit: {
		addons: Array<any>
		code: string | null
		description: string | null
		profileId: number | null
		resources: Array<any>
		viewCareStore: boolean
	}
	termsAndConditions: boolean
	informedConsent: boolean
	dataTreatment: boolean
	isLogin: boolean
	community: boolean
	companyName: boolean
	vitalPlanActivated: boolean
	enableCDCflow: boolean
	enrollmentOrigin: boolean
	resources?: Array<string>
}

const defaultState: ISession = {
	fullName: false,
	firstName: undefined,
	lastName: undefined,
	middleName: undefined,
	surname: undefined,
	needFirstReport: false,
	patients: [],
	services: [],
	userWithoutLogin: false,
	userGigya: false,
	registrationFinished: false,
	userMemberships: {
		sura: false,
		ipsComfama: false,
		boxComfama: false,
		suscription: false,
		haveCareCenterPlan: false
	},
	permit: {
		addons: [],
		code: null,
		description: null,
		profileId: null,
		resources: [],
		viewCareStore: false
	},
	termsAndConditions: false,
	informedConsent: false,
	dataTreatment: false,
	isLogin: false,
	community: false,
	companyName: false,
	vitalPlanActivated: false,
	enableCDCflow: false,
	enrollmentOrigin: false,
	resources: ['DF']
}

const reducerObject = ({ state, payload = false }: { state: any; payload: any }) => ({
	[sessionActionTypes.setUserInfo]: { ...state, ...payload },
	[sessionActionTypes.resetUserInfo]: defaultState,
	[sessionActionTypes.updatePathologyUser]: { ...state, pathologies: payload.pathologies },
	[sessionActionTypes.setPatientUser]: { ...state, patients: payload },
	[sessionActionTypes.updatePatientToUser]: { ...state, patients: payload },
	[sessionActionTypes.deletePatientUser]: {
		...state,
		patients:
			Array.isArray(state?.patients) && state?.patients?.length > 0
				? [...state?.patients?.filter((p: { userId: number }) => p?.userId !== parseInt(payload))]
				: []
	},
	[sessionActionTypes.setServiceUser]: { ...state, services: payload },
	[sessionActionTypes.activeSubscription]: {
		...state,
		userMemberships: { ...state.userMemberships, suscription: true }
	},
	[sessionActionTypes.setResourcesUser]: { ...state, resources: payload.resources }
})

const reducer = (state: ISession = defaultState, action: any) =>
	reducerObject({ state, payload: action.payload })[action.type] || state

export default reducer
